import { Injectable } from '@angular/core';
import { StorageProvider } from '../services/storage.provider';

@Injectable({ providedIn: 'root' })
export class Logout {
  constructor(private storage: StorageProvider) {}

  logOut() {
    this.storage.removeStorage('access_token');
    this.storage.removeStorage('refresh_token');
    this.storage.removeStorage('logged_profile_id');
    this.storage.removeStorage('logged_profile_name');
    this.storage.removeStorage('logged_profile_type');
    this.storage.removeStorage('logged_profile_avatar');
    this.storage.removeStorage('logged_profile_nickname');
    this.storage.removeStorage('access');
    this.storage.removeStorage('mainaccess');
    this.storage.removeStorage('printaccess');
    this.storage.removeStorage('pdfaccess');
    this.storage.removeStorage('hybridApp');
    this.storage.removeStorage('uit');
  }

  profileLogOut() {
    this.storage.removeStorage('logged_profile_id');
    this.storage.removeStorage('logged_profile_name');
    this.storage.removeStorage('logged_profile_type');
    this.storage.removeStorage('logged_profile_avatar');
    this.storage.removeStorage('logged_profile_nickname');
    this.storage.removeStorage('access');
    this.storage.removeStorage('mainaccess');
    this.storage.removeStorage('printaccess');
    this.storage.removeStorage('pdfaccess');
    this.storage.removeStorage('hybridApp');
  }
}
